
import React, { useState, useEffect } from 'react';

const DigitalClock: React.FC = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timerId = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timerId);
  }, []);

  const formatTime = (date: Date) => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return { hours, minutes, seconds };
  };

  const { hours, minutes, seconds } = formatTime(time);

  return (
    <div className="text-xl md:text-2xl font-mono text-neon-cyan neon-text-cyan bg-black/30 px-3 py-1 rounded-md border border-neon-cyan/50">
      <span>{hours}</span>
      <span className="animate-blink">:</span>
      <span>{minutes}</span>
      <span className="animate-blink">:</span>
      <span>{seconds}</span>
    </div>
  );
};

export default DigitalClock;
